import React, { useState } from 'react'
import { supabase } from '../../lib/supabaseClient'

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setMessage(null)
    setError(null)
    setLoading(true)

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/auth/reset-password`
    })

    setLoading(false)

    if (error) {
      setError("Impossible d'envoyer l'email de réinitialisation.")
      return
    }

    setMessage('Si un compte existe avec cet email, un lien de réinitialisation a été envoyé.')
  }

  return (
    <div className="card">
      <div className="card-header">
        <h1 className="card-title">Mot de passe oublié</h1>
        <p style={{ fontSize: '.85rem', color: '#9ca3af' }}>
          Indique l’adresse email de ton compte.
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '0.75rem' }}>
          <label className="label">Email</label>
          <input
            className="input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>

        {error && <p style={{ color: '#f97373', fontSize: '.85rem' }}>{error}</p>}
        {message && <p style={{ color: '#22c55e', fontSize: '.85rem' }}>{message}</p>}

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Envoi…' : 'Envoyer le lien de réinitialisation'}
        </button>
      </form>
    </div>
  )
}

export default ForgotPasswordPage
